import { takeLatest, all, put, call } from 'redux-saga/effects';
import * as calls from './calls';
import * as reducerActions from '../../reducers/proveedoresReducer/actions';
import * as Notifications from '../../components/Common/notification';
import * as layoutActions from '../../reducers/layoutReducer/actions';

function* genGetAllProveedores() {
    try {
        yield put(layoutActions.setLoading({ show: true, message: 'Obteniendo proveedores' }));
        let proveedores = yield call(calls.GetAllProveedores);
        yield put(reducerActions.setProveedores(proveedores));
    } catch (error) {
        if (error.message) {
            Notifications.showError(error.message);
        }
    } finally {
        yield put(layoutActions.setLoading({ show: false }));
    }
}

function* genGetProveedor(e) {
    try {
        yield put(layoutActions.setLoading({ show: true, message: 'Cargando proveedor' }));
        let proveedor = yield call(calls.GetProveedor, e.payload.idProveedor);
        yield put(reducerActions.saveProveedor(proveedor));
    } catch (error) {
        if (error.message) {
            Notifications.showError(error.message);
        }
    } finally {
        yield put(layoutActions.setLoading({ show: false }));
    }
}

function* genGetProveedorByCodigo(e) {
    try {
        yield put(layoutActions.setLoading({ show: true, message: 'Cargando proveedor' }));
        let proveedor = yield call(calls.getProveedorByCodigo, e.payload.codigo);
        yield put(reducerActions.saveProveedor(proveedor));
    } catch (error) {
        if (error.message) {
            Notifications.showError(error.message);
        }
    } finally {
        yield put(layoutActions.setLoading({ show: false }));
    }
}

function* genGetProveedorByNombre(e) {
    try {
        yield put(layoutActions.setLoading({ show: true, message: 'Cargando proveedor' }));
        let proveedor = yield call(calls.getProveedorByNombre, e.payload.nombre);
        yield put(reducerActions.saveProveedor(proveedor));
    } catch (error) {
        if (error.message) {
            Notifications.showError(error.message);
        }
    } finally {
        yield put(layoutActions.setLoading({ show: false }));
    }
}

function* genSaveProveedor(e) {
    try {
        yield call(calls.saveProveedor, e.payload);
        if (e.payload.idProveedor !== 0) {
            Notifications.showSuccess("Proveedor actualizado");
        } else {
            Notifications.showSuccess("Proveedor creado");
        }
        window.history.back();
    } catch (error) {
        Notifications.showError(error.message);
    }
}

function* genDeleteProveedor(e) {
    try {
        yield put(layoutActions.setLoading({ show: true, message: 'Eliminando proveedor' }));
        yield call(calls.deleteProveedor, e.payload.idProveedor);
        yield put(layoutActions.setLoading({ show: false }));
        Notifications.showSuccess("Proveedor eliminado");
        yield put(reducerActions.sagaGetProveedores());
    } catch (error) {
        yield put(layoutActions.setLoading({ show: false }));
        Notifications.showError(error.message || "Error al eliminar el proveedor");
    }
}

function* defaultSaga() {
    yield all([
        takeLatest(reducerActions.SAGA_GET_PROVEEDORES, genGetAllProveedores),
        takeLatest(reducerActions.SAGA_GET_PROVEEDOR, genGetProveedor),
        takeLatest(reducerActions.SAGA_GET_PROVEEDOR_BY_CODIGO, genGetProveedorByCodigo),
        takeLatest(reducerActions.SAGA_GET_PROVEEDOR_BY_NOMBRE, genGetProveedorByNombre),
        takeLatest(reducerActions.SAGA_SAVE_PROVEEDOR, genSaveProveedor),
        takeLatest(reducerActions.SAGA_ELIMINAR_PROVEEDOR, genDeleteProveedor),
    ]);
}

export const sagas = [
    defaultSaga
];